module.exports = __webpack_public_path__ + "static/media/spectrophotometer-info-7.10891c7f.svg";